module.exports = __webpack_public_path__ + "static/img/logo.ea34cf8c.png";